import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@shared/components/icon/icon.module';

import { NotificationComponent } from './notification.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  declarations: [NotificationComponent],
  entryComponents: [NotificationComponent]
})
export class NotificationModule { }
